var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseLogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 29.806V24.4727H50.6667V19.1393C50.6624 17.7261 50.0992 16.372 49.0999 15.3727C48.1006 14.3735 46.7465 13.8102 45.3333 13.806H40V8.47266H34.6667V13.806H29.3333V8.47266H24V13.806H18.6667C17.2535 13.8102 15.8994 14.3735 14.9001 15.3727C13.9008 16.372 13.3376 17.7261 13.3333 19.1393V24.4727H8V29.806H13.3333V35.1393H8V40.4727H13.3333V45.806C13.3376 47.2192 13.9008 48.5733 14.9001 49.5726C15.8994 50.5718 17.2535 51.1351 18.6667 51.1393H24V56.4727H29.3333V51.1393H34.6667V56.4727H40V51.1393H45.3333C46.7465 51.1351 48.1006 50.5718 49.0999 49.5726C50.0992 48.5733 50.6624 47.2192 50.6667 45.806V40.4727H56V35.1393H50.6667V29.806H56ZM45.3333 45.806H18.6667V19.1393H45.3333V45.806Z",
    fill: "url(#paint0_linear_78_375)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.296 21.806H26.7093L21.3493 43.1394H24.088L25.3253 38.1394H31.5013L32.7066 43.1394H35.5386L30.296 21.806ZM25.6853 36.0034L28.4 24.3394H28.5226L31.144 36.0034H25.6853ZM37.984 21.806H40.6506V43.1394H37.984V21.806Z",
    fill: "url(#paint1_linear_78_375)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_375",
    x1: 32,
    y1: 8.47266,
    x2: 32,
    y2: 56.4727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_78_375",
    x1: 31,
    y1: 21.806,
    x2: 31,
    y2: 43.1394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseLogo3);
export default __webpack_public_path__ + "static/media/case-logo-3.dc4e86ab2f061e8c896d961eda9e3078.svg";
export { ForwardRef as ReactComponent };